// Luồng donate trực tiếp toàn trang.
export interface LiveDonate {
  id: string;
  donorName: string;
  donorUserName: string | null;
  creatorId: string;
  creatorName: string;
  creatorUserName: string | null;
  amount: number;
  createdAt: string;
}

export const mergeLiveDonates = (current: LiveDonate[], incoming: LiveDonate[], limit: number): LiveDonate[] => {
  const byId = new Map<string, LiveDonate>();
  [...incoming, ...current].forEach((x) => {
    if (!byId.has(x.id)) byId.set(x.id, x);
  });
  return Array.from(byId.values())
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, limit);
};

/**
 * Thời gian tương đối kiểu "2 phút trước", tính thuần từ `nowMs` (không tự đọc đồng hồ hệ thống)
 * để component gọi lại được mỗi khi `now` tick mà không cần re-mount — khác với
 * `dayjs.utc(x).fromNow()` vốn tính một lần lúc render rồi đứng yên.
 */
export const formatLiveAgo = (createdAtIso: string, nowMs: number): string => {
  const createdMs = new Date(createdAtIso).getTime();
  const diffSec = Math.floor((nowMs - createdMs) / 1000);
  if (diffSec < 60) return 'vừa xong';
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin} phút trước`;
  const diffHour = Math.floor(diffMin / 60);
  if (diffHour < 24) return `${diffHour} giờ trước`;
  const d = new Date(createdMs);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};
